export const PAGE_SIZES = {
  A4: { width: 210, height: 297, unit: 'mm' },
  Letter: { width: 215.9, height: 279.4, unit: 'mm' },
  Legal: { width: 215.9, height: 355.6, unit: 'mm' },
  A3: { width: 297, height: 420, unit: 'mm' },
  A5: { width: 148, height: 210, unit: 'mm' },
};

export const DEFAULT_SETTINGS = {
  pageSize: 'A4',
  customWidth: 210,
  customHeight: 297,
  customUnit: 'mm',
  orientation: 'auto',
  fitMode: 'fit',
  margin: 12,
  blankPages: 'none',
  filename: 'converted-images.pdf',
  showPageNumbers: false,
  showDetails: false,
  imagesPerPage: 1,
  imageBackground: '#ffffff',
};